<template>
  <v-row>
    <v-col v-for="app in applications" :key="app.id">
      <AppCard
        :title="app.title"
        :description="app.description"
        :tag="app.tag"
        :image="app.image"
        :button-only="app.buttonOnly"
        :link="app.link"
      />
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import AppCard from '@/components/AppCard.vue'
import { useGetApplicationList } from '@/behaviors/application/useGetApplicationList'
import { resolveAppLink } from '@/utils/generateUrlApps'

interface AppView {
  id: string
  slug: string
  title?: string
  description?: string
  tag?: string
  image: string
  buttonOnly?: string
  link: string
}

const { applications: rawApplications } = useGetApplicationList()

const applications = computed<AppView[]>(() =>
  rawApplications.value
    .map((a) => ({
      id: a.id,
      slug: a.slug,
      title: a.title,
      description: a.description,
      tag: a.tag,
      image: a.image,
      buttonOnly: a.buttonOnly,
      link: a.link || resolveAppLink(a.slug) || '',
    }))
    .filter((a) => a.link !== ''),
)
</script>

<style scoped></style>
